<style lang="scss" scoped>
@use '~@/styles/base/variables';

div {
  // border: 1px dotted lightgreen;
}

.flex {
  display: flex;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.smart-trade {
  --content-gap: 15px;
  padding: 20px;
  background-color: var(--color-card);
  height: 100%;
  overflow: auto;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &_blur {
    opacity: 0.7;
  }

  @media screen and (max-width: variables.$standart) {
    --content-gap: 10px;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 10px;

  &__balance {
    font-size: 16px;
  }
}

.buy-sell-container {
  display: block;
  margin-bottom: var(--content-gap);

  &__btn {
    width: 50%;
  }
}

.trade-btn {
  &.buy {
    background-image: linear-gradient(
      to bottom left,
      var(--color-success),
      var(--color-success-dark)
    ) !important;
  }
  &.sell {
    background-image: linear-gradient(
      to bottom left,
      var(--color-danger),
      var(--color-danger-dark)
    ) !important;
  }
}

.control-wrapper {
  text-align: left;
  margin-bottom: var(--content-gap);
}

.label-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;

  .label {
    margin-bottom: 0;
  }
}

.label {
  display: block;
  text-align: left;
  margin-bottom: 5px;
}

.control {
  margin-bottom: 5px;

  &__prepend {
    display: block;
    min-width: 75px;
    font-size: 14px;
    cursor: pointer;
  }

  &__append {
    display: block;
    min-width: 42px;
    font-size: 14px;
  }

  @media screen and (max-width: variables.$standart) {
    margin-bottom: 0;

    &__prepend {
      font-size: 12px;
    }

    &__append {
      font-size: 12px;
    }
  }
}

.caption {
  font-size: 12px;
  color: var(--color-danger-light);
  height: 14px;

  &_warning {
    color: var(--color-warning);
  }
}

.balance-procent {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 5px;

  &__item {
    text-align: left;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.order-protection {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;

  &__item {
    cursor: pointer;
  }

  &__value {
    display: inline-block;
    min-width: 42px;
    text-align: left;
    margin-left: 2px;
  }

  &__sl {
    color: var(--color-danger-light);
  }

  &__tp {
    color: var(--color-success-light);
  }

  @media screen and (max-width: variables.$standart) {
    font-size: 14px;
  }
}

.futures-panel {
  $futures-panel-gap: 10px;
  $futures-panel-margin-type-width: 76px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: var(--content-gap);
  font-size: 14px;
  gap: $futures-panel-gap;

  &__right {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: $futures-panel-gap;
    flex: auto;
  }

  &__icon {
    margin-bottom: 2px;
    margin-right: $futures-panel-gap;
  }

  &__link {
    color: var(--color-accent-dark);
  }

  &__deposit {
    display: inline-block;
    margin-left: $futures-panel-gap;
    min-width: 40px;
    text-align: left;
  }

  &__leverage-slider {
    height: 10px;
    margin-top: -30px;
    min-width: 80px;
    max-width: 200px;
    flex: auto;
  }

  &__margin-type-wrapper {
    min-width: 2 * $futures-panel-margin-type-width;
  }

  &__margin-type {
    width: $futures-panel-margin-type-width;
  }

  @media screen and (max-width: variables.$standart) {
    font-size: 12px;
  }
}
</style>

<template>
  <div style="position: relative">
    <div
      class="smart-trade"
      :class="{ 'smart-trade_blur': showSymbolsComponent }"
      ref="smartTrade"
    >
      <div class="header">
        <SymbolsChooser
          v-model="symbol"
          @click="selectSymbol"
          noRelative
        />
        <span
          v-if="$store.state.sys.freeBalance"
          class="header__balance"
          :class="{ 'blur-balance-span': $store.state.sys.hideBalances }"
        >
          <span>{{ balanceText }}</span>
        </span>
      </div>
      <RadioGroup
        class="buy-sell-container"
        type="button"
        :size="isMedium ? 'small' : 'default'"
        v-model="$store.state.trade.side"
        @on-change="sideChanged"
      >
        <Radio
          class="buy-sell-container__btn"
          label="B"
        >{{
          $text.tr('КУПИТЬ')
        }}</Radio>
        <Radio
          class="buy-sell-container__btn"
          label="S"
        >{{ $text.tr('ПРОДАТЬ') }}
        </Radio>
      </RadioGroup>
      <div class="control-wrapper">
        <label
          class="label"
          for="price-input"
        >{{ $text.tr('ЦЕНА') }}</label>
        <i-input
          element-id="price-input"
          class="control"
          :size="isStandart ? 'default' : 'large'"
          :value="$store.state.trade.type === 'market' ? $store.state.sys.lastPrice : $store.state.trade.price"
          :disabled="$store.state.trade.type === 'market'"
          @on-keydown="onkeyDown($event)"
          @on-change="priceChanged"
        >
          <span
            slot="prepend"
            class="control__prepend noselect"
            @click="limmarketswitch"
          >
            {{ tradeType }}&nbsp;
            <Icon type="ios-arrow-down" />
          </span>
          <span
            slot="append"
            class="control__append"
          >
            {{ $store.state.trade.pair[1] }}
          </span>
        </i-input>
        <div
          class="caption"
          :class="{ caption_warning: !priceError.length }"
        >
          {{ priceError.length ? priceError : priceWarning }}
        </div>
      </div>
      <div class="control-wrapper">
        <label
          class="label"
          for="qty-input"
        >{{ $text.tr('КОЛ-ВО') }}</label>
        <i-input
          element-id="qty-input"
          class="control"
          :value="$store.state.trade.qty"
          :size="isStandart ? 'default' : 'large'"
          @on-keydown="onkeyDown($event)"
          @on-change="qtyChanged"
        >
          <span
            slot="append"
            class="control__append"
          >
            {{ $store.state.trade.pair[0] }}
          </span>
        </i-input>
        <div class="caption">
          {{ qtyError ? qtyError : sltpError }}
        </div>
      </div>
      <div class="control-wrapper">
        <div class="label-wrapper">
          <label
            class="label"
            for="amount-input"
          >
            {{ $text.tr('СУММА') }}
          </label>
          <div class="balance-procent">
            <span
              v-for="pct in balanceProcents"
              :key="pct"
              class="balance-procent__item"
              @click="autoamount('' + pct / 100)"
            >{{ pct }}%</span>
          </div>
        </div>
        <i-input
          element-id="amount-input"
          class="control"
          :size="isStandart ? 'default' : 'large'"
          :value="$store.state.trade.amount"
          @on-keydown="onkeyDown($event)"
          @on-change="totChanged"
        >
          <span
            slot="append"
            class="control__append"
          >
            {{ $store.state.trade.pair[1] }}
          </span>
        </i-input>
        <div class="caption"> {{ totalError }} </div>
      </div>
      <div
        v-if="!$store.getters.isFutures"
        class="order-protection"
      >
        <span
          class="order-protection__item"
          @click="showSltp()"
        >
          <span class="order-protection__sl">Stop Loss:</span>
          <span class="order-protection__value">
            {{
              parseFloat($store.state.trade.slprice) > 0
                ? parseFloat($store.state.trade.sltrail) > 0
                  ? $store.state.trade.slprice + ' trail'
                  : $store.state.trade.slprice
                : $text.tr('нет')
            }}
          </span>
        </span>
        <span
          class="order-protection__item"
          @click="showSltp()"
        >
          <span class="order-protection__tp">Take Profit:</span>
          <span class="order-protection__value">
            {{
              $store.state.trade.tpprice > 0
                ? $store.state.trade.tptrail > 0
                  ? $store.state.trade.tpprice + ' trail'
                  : $store.state.trade.tpprice
                : $text.tr('нет')
            }}
          </span>
        </span>
      </div>
      <div
        v-else
        class="futures-panel"
      >
        <!-- <div class="futures-panel__left"> -->
          <!-- <Icon @click="leverageClicked(-1)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer"
                    type="md-remove"
                    size="22"
                  ></Icon> -->
          <!-- <Tooltip
            placement="right"
            max-width="260"
            :delay="500"
          >
            <Icon
              class="futures-panel__icon"
              type="ios-information-circle-outline"
              color="var(--color-text-dark)"
            />
            <div slot="content">
              {{
                $text.tr(
                  'Залог - сумма средств, которыми вы рискуете, используя изолированную маржу. В случае кросс-маржи залогом является весь баланс счета. Внимание: Изменение плеча затронет все выставленные на бирже ордера по данной паре. Сумма залога для каждого ордера будет пересчитана.'
                )
              }}
              <a
                class="futures-panel__link"
                target="_blank"
                :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')"
              >{{ $text.tr('Подробнее') }}</a>
            </div>
          </Tooltip>
          <span>{{ $text.tr('ЗАЛОГ1') }}</span>
          <span class="futures-panel__deposit">
            {{ depositBIF }}
          </span> -->
        <!-- </div> -->
        <div class="futures-panel__right">
          <Icon @click="leverageClicked(-1)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer"
                    type="md-remove"
                    size="22"
                  ></Icon>
          <RadioGroup
            v-if="$store.getters.isFTXFutures"
            type="button"
            size="small"
            v-model="$store.state.trade.leverage"
            @on-change="leverageChanged"
          >
            <Radio
              v-for="lvg in ftxLeverages"
              :label="lvg"
              :key="'lvg ' + lvg"
              class="futures-panel__ftx-leverage-item"
            >{{ lvg }}X</Radio>
          </RadioGroup>
          <template v-else>
            <Slider
              class="futures-panel__leverage-slider"
              v-model="$store.state.trade.leverage"
              @on-change="leverageChanged"
              :min="1"
              :max="75"
              :step="1"
              show-tip="never"
            >
            </Slider>
            <Icon @click="leverageClicked(1)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer"
                    type="md-add"
                    size="22"
                  ></Icon>
            <span style="min-width: 25px;">
              <b>{{ $store.state.trade.leverage }}X</b>
            </span>
            <RadioGroup
              class="flex"
              type="button"
              size="small"
              v-model="$store.state.trade.marginType"
              @on-change="marginTypeChanged"
            >
              <Radio
                label="cross"
                :title="$text.tr('Риск всем депозитом')"
                class="futures-panel__margin-type"
              >CROSS</Radio>
              <Radio
                label="isolated"
                :title="$text.tr('Риск только залогом')"
                class="futures-panel__margin-type"
              >ISOLATED</Radio>
            </RadioGroup>
          </template>
        </div>
        <div style="margin-top: 5px;">
          <Tooltip
            placement="right"
            max-width="260"
            :delay="500"
          >
            <Icon
              class="futures-panel__icon"
              type="ios-information-circle-outline"
              color="var(--color-text-dark)"
            />
            <div slot="content">
              {{
                $text.tr(
                  'Залог - сумма средств, которыми вы рискуете, используя изолированную маржу. В случае кросс-маржи залогом является весь баланс счета. Внимание: Изменение плеча затронет все выставленные на бирже ордера по данной паре. Сумма залога для каждого ордера будет пересчитана.'
                )
              }}
              <a
                class="futures-panel__link"
                target="_blank"
                :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')"
              >{{ $text.tr('Подробнее') }}</a>
            </div>
          </Tooltip>
          <span>{{ $text.tr('ЗАЛОГ') }}</span>
          <span class="futures-panel__deposit">
            {{ depositBIF }}
          </span>
        </div>
      </div>
      <Button
        @click="trade()"
        :size="isMedium ? 'small' : 'large'"
        class="trade-btn"
        :class="[$store.state.trade.side === 'B' ? 'buy' : 'sell']"
        long
        style="width: 100%"
        :disabled="
          $store.state.trade.qty === '0' ||
            priceError !== '' ||
            qtyError !== '' ||
            totalError !== '' ||
            sltpError != ''
        "
      >{{
          $store.state.trade.side === 'B'
            ? $text.tr('КУПИТЬ')
            : $text.tr('ПРОДАТЬ')
        }}
        {{ $store.state.trade.pair[0] }}
        {{ $store.state.trade.type === 'market' ? $text.tr('ПО РЫНКУ') : '' }}
      </Button>
    </div>
    <ConfirmTradeModal />
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import terminal from '@/services/terminal'
import ConfirmTradeModal from './ConfirmTradeModal'
import Api from '@/util/api'
import SymbolsChooser from '@/components/common/SymbolsChooser'

export default {
  name: 'Terminal',
  components: {
    ConfirmTradeModal,
    SymbolsChooser
  },
  data: function () {
    return {
      qtyError: '',
      priceError: '',
      priceWarning: '',
      totalError: '',
      sltpError: '',
      qtyFocused: false,
      showSymbolsComponent: false,
      balanceProcents: [1, 5, 10, 25, 50, 75, 100],
      ftxLeverages: [1, 3, 5, 10, 20, 50],
      isStandart: false,
      isMedium: false,
      isExchChanged: false
    }
  },
  watch: {
    '$store.state.sys.tradeExchange.Id': function (exchId) {
      this.symbolChanged(this.$store.state.trade.symbol)
      this.isExchChanged = true
    },
    '$store.state.trade.side': function (side) {
      if (this.$store.getters.isOKXFutures || this.$store.getters.isBYF || this.$store.getters.isBitgetFutures) {
        this.symbolChanged(this.$store.state.trade.symbol)
      }
    },
    '$store.state.trade.symbol': function (symbol) {
      if (this.isExchChanged) {
        this.isExchChanged = false
        return
      }

      this.symbolChanged(symbol)
    },
    '$store.state.sltpModal': function (showModal) {
      if (!showModal) {
        this.checkErrors()
      }
    },
    '$store.state.trade.price': function () {
      if (!this.$store.state.trade.price) {
        return
      }
      if (this.qtyFocused) {
        this.$store.state.trade.amount = terminal
          .returnDecimalValue(this.$store.state.trade.qty)
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      } else {
        if (
          !terminal.returnDecimalValue(this.$store.state.trade.price).equals(0)
        ) {
          const filter = this.symbolsFilter[this.$store.state.trade.symbol]
          let qtyDec = 8
          if (filter) {
            qtyDec = filter.QtyDec
          }
          this.$store.state.trade.qty = terminal
            .returnDecimalValue(this.$store.state.trade.amount)
            .dividedBy(this.$store.state.trade.price)
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()
        }
      }
      this.checkErrors()
    },
    '$store.state.sys.lastTrade': function () {
      this.$store.dispatch('updateAssetBalance', true)
    },
    '$store.state.trade.leverage': function (leverage) {
      localStorage.setItem('capico_app_leverage', JSON.stringify(leverage))
      this.checkErrors()
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize)
  },
  created () {
    this.applyOKXMarginType()
  },
  mounted () {
    this.onResize()

    window.addEventListener('resize', this.onResize, { passive: true })

    Decimal.set({ toExpNeg: -10 })
    this.$store.dispatch('updateAssetBalance')
    this.symbolChanged(this.$store.state.trade.symbol)
  },
  computed: {
    symbolsFilter () {
      return this.$store.state.data.symbolsfilter
    },
    symbol: {
      get () {
        if (
          this.$store.getters.isFTXFutures ||
          this.$store.getters.isOKXFutures
        ) {
          return this.$store.state.trade.pair[0]
        }
        return (
          this.$store.state.trade.pair[0] +
          '/' +
          this.$store.state.trade.pair[1]
        )
      },
      set (value) {}
    },
    depositBIF () {
      return (
        '$' +
        terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .div(this.$store.state.trade.leverage)
          .toDP(2)
          .toString()
      )
    },
    tradeType () {
      switch (this.$store.state.trade.type) {
        case 'limit':
          return this.$text.tr('Лимитный')
        case 'market':
          return this.$text.tr('По рынку')
        case 'cond':
          return this.$text.tr('Отлож.')
      }
      return this.$store.state.trade.type === 'limit'
        ? this.$text.tr('Лимитный')
        : this.$text.tr('По рынку')
    },
    balanceText () {
      let freeBalance = ''
      let asset = ''
      if (this.$store.getters.isFutures) {
        freeBalance = this.$store.state.sys.freeBalance
        asset = this.$store.state.trade.pair[1]
      } else {
        if (this.$store.state.trade.side === 'B') {
          freeBalance = this.$store.state.sys.freeBalance
          asset = this.$store.state.trade.pair[1]
        } else {
          freeBalance = this.$store.state.sys.freeBalance2
          asset = this.$store.state.trade.pair[0]
        }
      }
      return freeBalance + ' ' + asset
    }
  },
  methods: {
    applyOKXMarginType () {
      if (!this.$store.getters.isOKXFutures) {
        return
      }

      const marginType = localStorage.getItem('okx_marginType')
      this.$store.state.trade.marginType = marginType || 'isolated'
    },
    selectSymbol (symbol) {
      terminal.selectTerminalSymbol(symbol)
    },
    onResize () {
      this.isStandart = window.innerWidth < 1400
      this.isMedium = window.innerWidth < 1000
    },
    symbolChanged (symbol) {
      if (!this.$store.getters.isFutures) {
        return
      }

      this.applyOKXMarginType()
      terminal.getMargin({ symbol }).then(response => {
        if (!response.data || response.data.err) {
          return
        }

        // console.log(response.data)
        this.$store.state.trade.marginType = response.data.MarginType
        this.$store.state.trade.leverage = response.data.Leverage
      })
    },
    leverageClicked (leverage) {
      this.$store.state.trade.leverage += leverage
      const levsaved = this.$store.state.trade.leverage
      setTimeout(() => {
        if (levsaved === this.$store.state.trade.leverage) {
          this.leverageChanged(this.$store.state.trade.leverage)
        }
      }, 500)
    },
    leverageChanged (leverage) {
      if (!this.$store.getters.isFutures) {
        return
      }

      terminal
        .setMargin({ leverage, src: 'l' })
        .then(response => {
          if (!response.data) {
            return
          }

          if (response.data.err) {
            this.symbolChanged(this.$store.state.trade.symbol)
            return
          }

          this.$Notice.success({
            title: this.$text.tr('Плечо установлено: ') + leverage + 'X',
            duration: 3
          })
          this.$store.dispatch('updateTrades')
          setTimeout(() => {
            this.$store.dispatch('updateAssets')
            this.$store.dispatch('updateAssetBalance', true)
          }, 500)
        })
        .catch(() => {
          this.symbolChanged(this.$store.state.trade.symbol)
        })
    },
    marginTypeChanged (marginType) {
      if (
        this.$store.state.sys.tradeExchange.ExchId !== 'BIF' &&
        this.$store.state.sys.tradeExchange.ExchId !== 'OKX' &&
        !this.$store.getters.isBYF &&
        !this.$store.getters.isBitgetFutures
      ) {
        return
      }

      if (this.$store.state.sys.tradeExchange.ExchId === 'OKX') {
        localStorage.setItem('okx_marginType', marginType)
        this.symbolChanged(this.$store.state.trade.symbol)
        return
      }

      terminal.setMargin({ marginType, src: 'm' }).then(response => {
        if (!response.data) {
          return
        }

        if (response.data.err) {
          this.symbolChanged(this.$store.state.trade.symbol)
          return
        }

        if (this.$store.state.sys.tradeExchange.ExchId === 'OKX') {
          localStorage.setItem('okx_marginType', marginType)
        }

        if (this.$store.state.sys.tradeExchange.ExchId === 'GEF') {
          this.symbolChanged(this.$store.state.trade.symbol)
        }

        this.$Notice.success({
          title:
            this.$text.tr('Тип маржи установлен: ') + marginType.toUpperCase(),
          duration: 3
        })
      })
    },
    showSltp () {
      this.$store.state.sltpIndex = -1
      this.$store.state.sltpTrade = true
      this.$store.state.sltpModal = true
    },
    selectPrice (price) {
      this.$store.state.trade.price = new Decimal(price).toDP(8).toString()
    },
    trade () {
      if (this.$store.state.sys.isNoConfirmationMode) {
        terminal.ApiCreateTrade(this)
      } else {
        this.$store.state.confirmModal.show = true
      }
    },
    numAfterDot (numb) {
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    checkErrors () {
      if (this.$store.state.trade.qty === '') {
        return
      }
      if (this.$store.state.trade.price === '') {
        return
      }
      const filt = this.symbolsFilter[this.$store.state.trade.symbol]
      if (!filt) {
        return
        // console.log('wrong filter: ' + this.$store.state.trade.symbol)
        // console.log(this.symbolsFilter)
      }

      const bal1 =
        this.$store.state.trade.side === 'B' || this.$store.getters.isFutures
          ? this.$store.state.sys.freeBalance === ''
            ? '0'
            : this.$store.state.sys.freeBalance
          : this.$store.state.sys.freeBalance2

      if (
        !this.$store.getters.isFutures &&
        this.$store.state.trade.side === 'S' &&
        parseFloat(this.$store.state.trade.qty) > parseFloat(bal1)
      ) {
        this.qtyError = this.$text.tr('Недостаточно средств')
      } else if (
        new Decimal(this.$store.state.trade.qty).lessThan(filt.QtyMin)
      ) {
        this.qtyError = this.$text.tr('Минимальное кол-во: ') + filt.QtyMin
      } else if (this.numAfterDot(this.$store.state.trade.qty) > filt.QtyDec) {
        this.qtyError =
          this.$text.tr('Максимальное число знаков после запятой: ') +
          filt.QtyDec
      } else {
        this.qtyError = ''
      }

      if (
        !this.$store.getters.isFutures &&
        this.$store.state.trade.side === 'B' &&
        parseFloat(this.$store.state.trade.amount) > parseFloat(bal1)
      ) {
        this.totalError = this.$text.tr('Недостаточно средств')
      } else if (
        terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .lessThan(filt.AmountMin)
      ) {
        this.totalError = this.$text.tr('Минимальная сумма: ') + filt.AmountMin
      } else {
        this.totalError = ''
      }

      if (
        this.$store.state.trade.type === 'cond' &&
        this.$store.state.trade.side === 'B' &&
        new Decimal(this.$store.state.trade.price).lessThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        // this.priceError = 'Цена должна быть выше рыночной'
      } else if (
        this.$store.state.trade.type === 'cond' &&
        this.$store.state.trade.side === 'S' &&
        new Decimal(this.$store.state.trade.price).greaterThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        // this.priceError = 'Цена должна быть ниже рыночной'
      } else if (
        this.numAfterDot(this.$store.state.trade.price) > filt.PriceDec
      ) {
        this.priceError =
          this.$text.tr('Максимальное число знаков после запятой: ') +
          filt.PriceDec
        return
      } else {
        this.priceError = ''
      }

      if (
        this.$store.state.sys.tradeExchange.ExchId === 'BIF' &&
        this.$store.state.trade.type === 'limit' &&
        this.$store.state.trade.side === 'B' &&
        new Decimal(this.$store.state.trade.price).greaterThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceError = this.$text.tr('Цена должна быть ниже рыночной')
      } else if (
        this.$store.state.sys.tradeExchange.ExchId === 'BIF' &&
        this.$store.state.trade.type === 'limit' &&
        this.$store.state.trade.side === 'S' &&
        new Decimal(this.$store.state.trade.price).lessThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceError = this.$text.tr('Цена должна быть выше рыночной')
      }

      if (
        this.$store.getters.isBYF &&
        this.$store.state.trade.type === 'limit' &&
        filt.PriceMin.last !== 1
      ) {
        if (!new Decimal(this.$store.state.trade.price).div(filt.PriceMin).isInt()) {
          this.priceError = this.$text.tr('Цена должна быть кратна ' + filt.PriceMin)
        }
      }

      if (
        this.$store.state.trade.type === 'cond' &&
        new Decimal(this.$store.state.trade.price).lessThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceWarning =
          this.$text.tr('Будет исполнен, когда цена будет ≤ ') +
          this.$store.state.trade.price
        this.$store.state.trade.direction = 'B'
      } else if (
        this.$store.state.trade.type === 'cond' &&
        new Decimal(this.$store.state.trade.price).greaterThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceWarning =
          this.$text.tr('Будет исполнен, когда цена будет ≥ ') +
          this.$store.state.trade.price
        this.$store.state.trade.direction = 'A'
      } else {
        this.priceWarning = ''
      }

      if (this.$store.getters.isFutures) {
        if (!this.$store.state.trade.leverage) {
          console.log('checkErrors: no leverage')
          return
        }
        const deposit = terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .div(this.$store.state.trade.leverage)
          .toDP(2)
        if (deposit.greaterThan(bal1)) {
          this.totalError = this.$text.tr('Недостаточно средств')
        }
      }
      this.checkSltpErrors()
    },
    checkSltpErrors () {
      const filt = this.symbolsFilter[this.$store.state.trade.symbol]
      const amountMin = new Decimal(1.05).mul(filt.AmountMin).toString()
      let minsum = new Decimal(10000)
      this.$store.state.trade.tpsteps.forEach(step => {
        const sum = new Decimal(step.Qty).mul(step.Price)
        if (sum.lessThan(minsum)) {
          minsum = sum
        }
      })
      if (
        this.$store.state.trade.side === 'B' &&
        this.$store.state.trade.slprice &&
        new Decimal(this.$store.state.trade.slprice)
          .mul(this.$store.state.trade.qty)
          .lessThan(amountMin)
      ) {
        this.sltpError =
          'Ошибка в Stop Loss. Кол-во должо быть больше ' +
          new Decimal(amountMin)
            .div(this.$store.state.trade.slprice)
            .toDP(filt.QtyDec, Decimal.ROUND_DOWN)
            .toString()
      } else if (
        this.$store.state.trade.side === 'S' &&
        this.$store.state.trade.tpprice &&
        new Decimal(this.$store.state.trade.tpprice)
          .mul(this.$store.state.trade.qty)
          .lessThan(amountMin)
      ) {
        this.sltpError =
          'Ошибка в Take Profit. Кол-во должо быть больше ' +
          new Decimal(amountMin)
            .div(this.$store.state.trade.tpprice)
            .toDP(filt.QtyDec, Decimal.ROUND_DOWN)
            .toString()
      } else if (minsum.lessThan(amountMin)) {
        if (!minsum.toNumber()) {
          return
        }

        const x = new Decimal(amountMin)
          .mul(this.$store.state.trade.qty)
          .div(minsum)
        this.sltpError =
          'Ошибка в лесенке. Кол-во должно быть больше ' +
          x.toDP(filt.QtyDec, Decimal.ROUND_DOWN).toString()
      } else {
        this.sltpError = ''
      }
    },
    priceChanged (e) {
      if (e.target) {
        this.$store.state.trade.price = e.target.value
          .replace('ю', '.')
          .replace(/[^\d.-]/g, '')
      }
      if (
        this.$store.state.trade.price.charAt(0) === '0' &&
        this.$store.state.trade.price.charAt(1) !== '.'
      ) {
        this.$store.state.trade.price = this.$store.state.trade.price.substring(
          1
        )
      }
      if (
        !terminal.returnDecimalValue(this.$store.state.trade.price).equals(0)
      ) {
        const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
        this.$store.state.trade.qty = terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
      }
      this.checkErrors()
    },
    totChanged (e) {
      this.qtyFocused = false
      this.$store.state.trade.amount = e.target.value
        .replace('ю', '.')
        .replace(/[^\d.-]/g, '')
      if (
        this.$store.state.trade.amount.charAt(0) === '0' &&
        this.$store.state.trade.amount.charAt(1) !== '.'
      ) {
        this.$store.state.trade.amount = this.$store.state.trade.amount.substring(
          1
        )
      }
      if (
        this.$store.state.trade.amount === '' ||
        this.$store.state.trade.amount === '0'
      ) {
        this.$store.state.trade.qty = '0'
      } else if (
        !terminal.returnDecimalValue(this.$store.state.trade.price).equals(0)
      ) {
        const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
        this.$store.state.trade.qty = new Decimal(
          this.$store.state.trade.amount
        )
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
      }
      this.recalculateSteps()
      this.checkErrors()
    },
    qtyChanged (e) {
      this.qtyFocused = true
      this.$store.state.trade.qty = e.target.value
        .replace('ю', '.')
        .replace(/[^\d.-]/g, '')
      if (
        this.$store.state.trade.qty.charAt(0) === '0' &&
        this.$store.state.trade.qty.charAt(1) !== '.'
      ) {
        this.$store.state.trade.qty = this.$store.state.trade.qty.substring(1)
      }
      if (
        this.$store.state.trade.qty === '' ||
        this.$store.state.trade.qty === '0'
      ) {
        this.$store.state.trade.amount = '0'
      } else {
        this.$store.state.trade.amount = terminal
          .returnDecimalValue(this.$store.state.trade.qty)
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      }
      this.recalculateSteps()
      this.checkErrors()
    },
    recalculateSteps () {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      let qtySum = new Decimal(0)
      this.$store.state.trade.tpsteps.forEach((step, index) => {
        if (index < this.$store.state.trade.tpsteps.length - 1) {
          step.Qty = new Decimal(this.$store.state.trade.qty)
            .mul(step.Pct)
            .mul('0.01')
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()
          qtySum = qtySum.add(step.Qty)
        } else {
          step.Qty = new Decimal(this.$store.state.trade.qty)
            .sub(qtySum)
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()
        }
      })
    },
    sideChanged () {
      this.$store.dispatch('cleanSltp')
      this.checkErrors()
    },
    onkeyDown (e) {
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return
      }

      if (!e.target.value.includes('.')) {
        if (e.key === ',' || e.key === 'ю') {
          // change ',' to '.'
          setTimeout(function () {
            e.target.value += '.'
          }, 4)
          e.preventDefault()
        } else if (e.key === '.') {
          // let '.' happen
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault()
      }
    },
    autoamount (pct) {
      let bal1 = this.$store.state.sys.freeBalance

      if (
        !this.$store.getters.isFutures &&
        this.$store.state.trade.side === 'S'
      ) {
        bal1 = this.$store.state.sys.freeBalance2
      }

      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      if (this.$store.getters.isFutures) {
        const total1 = new Decimal(bal1)
          .times(pct)
          .mul(this.$store.state.trade.leverage)
          .toDP(8)
        this.$store.state.trade.qty = total1
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
        this.$store.state.trade.amount = new Decimal(
          this.$store.state.trade.qty
        )
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      } else if (this.$store.state.trade.side === 'B') {
        const total = new Decimal(bal1).times(pct).toDP(8)
        this.$store.state.trade.qty = total
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
        this.$store.state.trade.amount = new Decimal(
          this.$store.state.trade.qty
        )
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      } else {
        this.$store.state.trade.qty = Decimal(bal1)
          .times(pct)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
        this.$store.state.trade.amount = new Decimal(
          this.$store.state.trade.qty
        )
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      }
      this.recalculateSteps()
      this.checkErrors()
    },
    limmarketswitch () {
      if (this.$store.state.trade.type === 'limit') {
        this.$store.state.trade.type = 'market'
      } else if (this.$store.state.trade.type === 'market') {
        this.$store.state.trade.type = 'cond'
      } else {
        this.$store.state.trade.type = 'limit'
      }
      localStorage.setItem(
        'capico_app_trade_type',
        this.$store.state.trade.type
      )
      this.checkErrors()
    }
  }
}
</script>
